module.exports = __webpack_public_path__ + "img/res6.b64b2d3a.jpg";